// react and mui stuff
import AspectRatio from "@mui/joy/AspectRatio"
import Card from "@mui/joy/Card"
import CardActions from "@mui/joy/CardActions"
import CardOverflow from "@mui/joy/CardOverflow"
import IconButton from "@mui/joy/IconButton"
import Tab from "@mui/joy/Tab"
import TabList from "@mui/joy/TabList"
import TabPanel from "@mui/joy/TabPanel"
import Tabs from "@mui/joy/Tabs"
import Tooltip from "@mui/joy/Tooltip"
import Typography from "@mui/joy/Typography"

import FourK from "@mui/icons-material/FourK"
import Hd from "@mui/icons-material/Hd"
import Smartphone from "@mui/icons-material/Smartphone"

// data and stuff
import wallpaperInfo from "../data/wallpapers.json";
import { imgSrc } from "../utils/backend"

type img = {
  path: string;
  name: string;
  hasVertical?: boolean
  has4k?: boolean
}

function WallpaperTab({img}: {img: img}) {
  return (
    <Card sx={{ maxWidth: '300px', width: "100%", margin: "10px" }}>
      <CardOverflow>
        <AspectRatio>
          <img
            src={imgSrc(`wallpapers/${img.path}/preview.jpg`)}
            alt="Wallpaper"
            width="960px"
            height="540px"
          />
        </AspectRatio>
      </CardOverflow>
      <Typography level="title-lg">{img.name}</Typography>
      <CardActions>
        {
          img.has4k !== false &&
          <Tooltip title="Download 4K Wallpaper">
            <IconButton target="_blank" href={imgSrc(`wallpapers/${img.path}/4k.png`)} component="a"><FourK/></IconButton>
          </Tooltip>
        }
        <Tooltip title="Download 1080p Wallpaper">
          <IconButton target="_blank" href={imgSrc(`wallpapers/${img.path}/1080.png`)} component="a"><Hd/></IconButton>
        </Tooltip>
        {
          img.hasVertical !== false && 
          <Tooltip title="Download Phone Wallpaper">
            <IconButton target="_blank" href={imgSrc(`wallpapers/${img.path}/vertical.png`)} component="a"><Smartphone/></IconButton>
          </Tooltip>
        }
      </CardActions>
    </Card>
  )
}

const sx: React.CSSProperties = {display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "center" }

export default function Wallpapers() {
  return (
    <div className="contentRoot">
      <h1>LDSG Wallpapers</h1>
      <Tabs>
        <TabList>
          <Tab value={0}>Logo On Polygons</Tab>
          <Tab value={1}>Logo On Sand</Tab>
          <Tab value={2}>Houses</Tab>
          <Tab value={3}>Houses (Colored)</Tab>
          <Tab value={4}>Icarus Banners</Tab>
        </TabList>
        <TabPanel value={0}>
          <div style={sx}>
            {wallpaperInfo.baseHex.map(w => <WallpaperTab key={w.path} img={w}/>)}
          </div>
        </TabPanel>
        <TabPanel value={1}>
          <div style={sx}>
            {wallpaperInfo.baseSand.map(w => <WallpaperTab key={w.path} img={w}/>)}
          </div>
        </TabPanel>
        <TabPanel value={2}>
          <div style={sx}>
            {wallpaperInfo.whiteHouses.map(w => <WallpaperTab key={w.path} img={w}/>)}
          </div>
        </TabPanel>
        <TabPanel value={3}>
          <div style={sx}>
            {wallpaperInfo.coloredHouses.map(w => <WallpaperTab key={w.path} img={w}/>)}
          </div>
        </TabPanel>
        <TabPanel value={4}>
          <div style={sx}>
            {wallpaperInfo.icarus.map(w => <WallpaperTab key={w.path} img={w}/>)}
          </div>
        </TabPanel>
      </Tabs>
    </div>
  )
}